// extracted by mini-css-extract-plugin
export default {"boxmodel":"SiteMap_boxmodel__1IxoP","mainmenu":"SiteMap_mainmenu__RI77C"};